import { encryptPayload } from "@/utils/cryptoUtils";
import { getPublicKey } from "@/api/request-encoding/getPublicKey";

export const registerUser = async (aadhar_number, mobile_number, password, recaptchaToken) => {
  try {
    console.log("Sending registration data:", {
      aadhar_number,
      mobile_number,
      password,
      recaptchaToken: recaptchaToken ? "Token provided" : "No token",
    });

    const publicKeyPem = await getPublicKey();
    const encryptedPayload = await encryptPayload(
      { aadhar_number, mobile_number, password, recaptchaToken },
      publicKeyPem
    );

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/register`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    console.log("Response status:", response.status);

    const responseText = await response.text();
    console.log("Response body (text):", responseText);

    let data;
    try {
      data = JSON.parse(responseText);
      console.log("Response body (parsed):", data);
    } catch (e) {
      console.log("Could not parse response as JSON");
    }

    if (!response.ok) {
      const errorMessage =
        data?.error ||
        data?.message ||
        data?.detail ||
        responseText ||
        "Registration failed";
      return Promise.reject(errorMessage);
    }

    return data || { status: "success" };
  } catch (error) {
    console.error("Registration error:", error);
    return Promise.reject(error?.message || "Registration failed");
  }
};
